import { LOGOUT, SET_PAYCHECKS_LIST } from "../actions/types";

const INITIAL_STATE = {
    list: []
};

const paycheckReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PAYCHECKS_LIST:
            return {
                ...state,
                list: action.payload.map(paycheck => {
                    return {
                        paycheckID: paycheck.paycheckID,
                        userID: paycheck.userID,
                        year: paycheck.year,
                        month: paycheck.month,
                        title: paycheck.title
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default paycheckReducer;